import { connect } from 'react-redux';
import Component from './Component';

import componentDidMount from './Handlers/componentDidMount';
import componentWillUnmount from './Handlers/componentWillUnmount';

import onClickEditSupplier from './Handlers/onClickEditSupplier';
import onCloseSupplierModal from './Handlers/onCloseSupplierModal';
import didUpdateSupplier from './Handlers/didUpdateSupplier';
import didDeleteSupplier from './Handlers/didDeleteSupplier';

import onClickNewSupplierItem from './Handlers/onClickNewSupplierItem';
import onClickEditSupplierItem from './Handlers/onClickEditSupplierItem';
import onCloseSupplierItemModal from './Handlers/onCloseSupplierItemModal';
import didCreateSupplierItem from './Handlers/didCreateSupplierItem';
import didUpdateSupplierItem from './Handlers/didUpdateSupplierItem';
import didDeleteSupplierItem from './Handlers/didDeleteSupplierItem';

const mapStateToProps = (state) => ({
  supplier: state.screens.SupplierView.supplier,
  showSupplierModal: state.screens.SupplierView.showSupplierModal,
  showSupplierItemModal: state.screens.SupplierView.showSupplierItemModal,
  supplierItemForEdit: state.screens.SupplierView.supplierItemForEdit,
});

const actionCreators = {
  componentDidMount,
  componentWillUnmount,
  onClickEditSupplier,
  onCloseSupplierModal,
  didUpdateSupplier,
  didDeleteSupplier,
  onClickNewSupplierItem,
  onClickEditSupplierItem,
  onCloseSupplierItemModal,
  didCreateSupplierItem,
  didUpdateSupplierItem,
  didDeleteSupplierItem,
};

export default connect(mapStateToProps, actionCreators)(Component);
